import { Flex } from '@grupoboticario/flora-react';

import { Skeleton } from 'components';

import Styles from './Card.styles';

export const CardSkeleton = () => {
  return (
    <Styles.Card data-testid='skeleton-card'>
      <Flex direction='column' gapY='$4' justify='space-between'>
        <Skeleton height='$10' width='100%' />

        <Skeleton height='$5' width='50%' />
      </Flex>

      <Styles.Divider variant='Line' />

      <Flex align='center' direction='column' gapY='$4' justify='space-between'>
        <Skeleton height='$5' width='100%' />

        <Skeleton height='$5' width='100%' />
      </Flex>

      <Styles.Divider variant='Line' />

      <Skeleton height='$10' width='100%' />
    </Styles.Card>
  );
};
